import { render, staticRenderFns } from "./MoveBetweenContainers.vue?vue&type=template&id=ec4622c8&scoped=true&"
import script from "./MoveBetweenContainers.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MoveBetweenContainers.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./MoveBetweenContainers.vue?vue&type=style&index=0&id=ec4622c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4622c8",
  null
  
)

export default component.exports